import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './graphql';
import { Ssp } from './components/Ssp';
import { GlobalStyle } from './GlobalStyle';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const renderAppToDOM = () =>
    root.render(
        <ApolloProvider client={apolloClient}>
            <GlobalStyle />
            <Ssp />
        </ApolloProvider>
    );

if (
    process.env.NODE_ENV === 'development' &&
    !process.env.REACT_APP_DISABLE_SERVICE_WORKER
) {
    const { worker } = require('./mocks/browser');
    worker.start().then(renderAppToDOM);
} else {
    renderAppToDOM();
}
